/*
import {
  hf,
  ht,
  cr,
  BtnC,
  GridC,
} from 'lib';
*/
import * as GridC from "./_cccGridC";
import * as BtnC from "./_cccBtnC";
import * as cr from './_cr';

import * as Iccv30 from './icvBaseK10Rz';

export const N = (pz: {
}) => {

  return (
    cr.c(Iccv30.N, {
      key: -10,
      cz: {
        bHome: false,
        pageName: '基本設定',
      },
      oClds: [

        cr.c(GridC.N, {
          key: -10,
          abtType: 'homeCmnz',
          lineCs: [
            {
              cellCs: [
              ]
            },
            {
              cellCs: [
                {
                  oClds: [
                    cr.c(BtnC.N, {
                      key: -10,
                      abtType: 'homeOrnz',
                      lblCz: {
                        textz: {
                          pfx: 'クライアント'
                        },
                      },
                      pslPtyz: {
                        onPress: () => {
                          cr.moveTo({
                            pageName: 'icvI19K10Rz',
                          });
                        }
                      },
                    })
                  ],
                },
                {
                  oClds: [
                    cr.c(BtnC.N, {
                      key: -10,
                      abtType: 'homeOrnz',
                      lblCz: {
                        textz: {
                          pfx: '祝日'
                        },
                      },
                      pslPtyz: {
                        onPress: () => {
                          cr.moveTo({
                            pageName: 'icv_60K10Rz',
                          });
                        }
                      },
                    })
                  ],
                },
                {
                  oClds: [
                    cr.c(BtnC.N, {
                      key: -10,
                      abtType: 'homeOrnz',
                      lblCz: {
                        textz: {
                          pfx: 'メールサーバ'
                        },
                      },
                      pslPtyz: {
                        onPress: () => {
                          cr.moveTo({
                            pageName: 'icvI20K10Rz',
                          });
                        }
                      },
                    })
                  ],
                },
              ]
            },
            {
              cellCs: []
            },
          ]
        })

      ]
    })
  );
};
